// src/firebase.js
import { initializeApp } from "firebase/app";
import { firebaseConfig } from './firebaseConfig';
import { getFirestore } from "firebase/firestore";
// 👇 Yeni eklenenler: Kimlik doğrulama kütüphaneleri
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 




const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// 👇 Giriş sistemini dışarı aktarıyoruz
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();